import React from 'react';
import strings from 'utils/strings';
import classNames from 'classnames';
import './styles.scss';

import {TEST_TYPES, TEST_TYPE_NAMES} from 'constants/index';

const testsWithInstruction = ['child-screening'];
class TestDispatchModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCreatingTests: false,
			groupId: '',
			hasConfirmedCost: false,
			childSelfStarting: false,
			infoCandidateAdmin: true,
			newTestCount: 1,
			type: '',
			availableTestTypes: [],
			isAddingGroup: false,
			availableLanguage: [],
			selectedLanguage: null,
		};
		this.setAvailableTypes = this.setAvailableTypes.bind(this);
	}
	componentDidMount() {
		const userLanguages = this.props.userLanguages?.[0];

		if (!userLanguages) {
			return;
		}

		const availableLanguages = [];
		let initialLanguageConfig = null;

		const searchAbaleLanguageFields = [
			'norwegian',
			'swedish',
			'english',
			'dutch',
			'german',
		];

		const searchAbaleSubscriptionFields = [
			'child',
			'youth',
			'adult',
			'norming_youth',
			'norming_child',
			'child_followup',
			'adult_followup',
			'youth_followup',
		];

		for (const field of searchAbaleLanguageFields) {
			if (userLanguages.hasOwnProperty(field)) {
				for (const subType of searchAbaleSubscriptionFields) {
					if (userLanguages[field][subType] === 1) {
						if (initialLanguageConfig === null) {
							initialLanguageConfig = userLanguages[field];
						}

						availableLanguages.push(userLanguages[field].language);
						break;
					}
				}
			}
		}

		if (initialLanguageConfig) {
			this.setAvailableTypes(initialLanguageConfig);
		}

		this.setState({
			availableLanguage: availableLanguages,
			selectedLanguage: availableLanguages[0] || null,
		});
	}

	setAvailableTypes(availableLanguages = {}) {
		const availableTests = [];

		const searchAbaleSubscriptionFields = [
			'adult',
			'youth',
			'norming_youth',
			'norming_child',
			'child',
			'youth_followup',
			'child_followup',
			'adult_followup',
		];

		for (const field of searchAbaleSubscriptionFields) {
			if (availableLanguages[field] === 1) {
				if (field === 'norming_youth' || field === 'youth') {
					availableTests.push(TEST_TYPES.YOUTH_SCREENING);
				}

				if (field === 'norming_youth' || field === 'youth_followup') {
					availableTests.push(TEST_TYPES.YOUTH_FOLLOWUP);
				}

				if (field === 'adult') {
					availableTests.push(TEST_TYPES.ADULT_SCREENING);
				}

				if (field === 'adult_followup') {
					availableTests.push(TEST_TYPES.ADULT_FOLLOWUP);
				}

				if (field === 'child_followup') {
					availableTests.push(TEST_TYPES.CHILD_FOLLOWUP);
				}

				if (field === 'child') {
					availableTests.push(TEST_TYPES.CHILD_SCREENING);
				}
			}
		}

		const uniqueAvailableTests = [...new Set(availableTests)];

		this.setState((prevState) => ({
			availableTestTypes: uniqueAvailableTests,
			type: uniqueAvailableTests.includes(prevState.type)
				? prevState.type
				: uniqueAvailableTests[0] || '',
		}));
	}

	getCandidateGenderLabel(currentTestUser, allTestUsers = []) {
		for (let i = 0; i < allTestUsers.length; i++) {
			const testsResults = allTestUsers[i].testResults;

			for (let j = 0; j < testsResults.length; j++) {
				if (
					testsResults[j].testUser &&
					testsResults[j].testUser.testUserId === currentTestUser &&
					testsResults[j].info
				) {
					const information = JSON.parse(testsResults[j].info);

					if (testsResults[j].type !== 'child') {
						if (information.gender === 'm') return strings.male;
						if (information.gender === 'f') return strings.female;
					}

					if (information.gender === 'm') return strings.boy;
					if (information.gender === 'f') return strings.girl;
				}
			}
		}

		return '-';
	}

	confirmDispatchSettings() {
		this.setState({
			groupId: null,
			hasConfirmedCost: true,
			selectedLanguage:
				this.state.selectedLanguage || this.state.availableLanguage[0],
			type: this.state.type || this.state.availableTestTypes[0],
		});
	}

	handleLanguageChange(language) {
		const userLanguages = this.props.userLanguages?.[0];

		this.setState({
			selectedLanguage: language,
		});

		if (userLanguages && userLanguages[language]) {
			this.setAvailableTypes(userLanguages[language]);
		}
	}

	determineBulkTestKeys(selectedType, currentTestUser, filteredTestResults) {
		for (let i = 0; i < filteredTestResults.length; i++) {
			const testsResults = filteredTestResults[i].testResults;
			for (let j = 0; j < testsResults.length; j++) {
				if (testsResults[j].testUser) {
					if (
						testsResults[j].testUser.testUserId ===
							currentTestUser.id &&
						testsResults[j].info
					) {
						if (testsResults[j].type === 'adult-screening') {
							const information = JSON.parse(
								testsResults[j].info
							);

							return {
								type: selectedType,
								email:
									information.email ||
									currentTestUser.email ||
									null,
								id: testsResults[j].testUser.testUserId,
							};
						} else if (testsResults[j].type === 'youth-screening') {
							const information = JSON.parse(
								testsResults[j].info
							);
							return {
								type: selectedType,
								email:
									information.email ||
									currentTestUser.email ||
									null,
								id: testsResults[j].testUser.testUserId,
							};
						} else if (testsResults[j].type === 'child') {
							const information = JSON.parse(
								testsResults[j].info
							);
							return {
								type: selectedType,
								id: testsResults[j].testUser.testUserId,
								email:
									information.email ||
									currentTestUser.email ||
									null,
							};
						}
					} else if (
						testsResults[j].testUser.testUserId ===
							currentTestUser.id &&
						testsResults[j].recipient
					) {
						return {
							type: selectedType,
							email: testsResults[j].recipient,
							id: testsResults[j].testUser.testUserId,
						};
					}
				}
			}
		}
		return {
			type: selectedType,
			email: currentTestUser.email || null,
			id: currentTestUser.id,
		};
	}

	determineGender(currentTestUser, allTestUsers) {
		for (let i = 0; i < allTestUsers.length; i++) {
			const testsResults = allTestUsers[i].testResults;
			for (let j = 0; j < testsResults.length; j++) {
				if (testsResults[j].testUser) {
					if (
						testsResults[j].testUser.testUserId ===
							currentTestUser &&
						testsResults[j].info
					) {
						const information = JSON.parse(testsResults[j].info);
						if (testsResults[j].type !== 'child') {
							if (information.gender === 'm') {
								return (
									<td className="lit-list__col small">
										{strings.male}
									</td>
								);
							} else if (information.gender === 'f') {
								return (
									<td className="lit-list__col small">
										{strings.female}
									</td>
								);
							}
						} else if (information.gender === 'm') {
							return (
								<td className="lit-list__col small">
									{strings.boy}
								</td>
							);
						} else if (information.gender === 'f') {
							return (
								<td className="lit-list__col small">
									{strings.girl}
								</td>
							);
						}
					}
				}
			}
		}
		return null;
	}

	render() {
		const {onSaveBulk} = this.props;
		const UsersGroups = this.props.userGroups || [];
		const groups = UsersGroups.map((userGroup) => userGroup.name);
		const filteredTestUsers = this.props.testUsers || [];

		const {
			hasConfirmedCost,
			newTestCount,
			availableTestTypes,
			isAddingGroup,
			availableLanguage,
			selectedLanguage,
			type,
			childSelfStarting,
			infoCandidateAdmin,
		} = this.state;

		const showInstructionOptions = testsWithInstruction.includes(type);

		const handleCancel = () => {
			this.props.closeWindow();
		};

		const handleSubmit = (event) => {
			event.preventDefault();

			const testTypes = [];

			for (let i = 0; i < filteredTestUsers.length; i++) {
				const determineData = this.determineBulkTestKeys(
					type,
					filteredTestUsers[i],
					this.props.batchedFilteredTestResults
				);

				if (determineData) {
					testTypes.push(determineData);
				}
			}

			onSaveBulk(
				type,
				1,
				groups.length ? this.state.groupId : null,
				selectedLanguage,
				filteredTestUsers,
				testTypes,
				childSelfStarting
			);
		};

		return (
			<div
				className="tdm-modal"
				onClick={() => {
					this.props.closeWindow();
				}}
			>
				<div
					className="tdm-modal__island"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div className="tdm-header">
						<div>
							<h3 className="tdm-title">Valgte testkandidater</h3>
							<p className="tdm-subtitle">
								{filteredTestUsers.length} kandidat(er) valgt
							</p>
						</div>

						<button
							type="button"
							className="tdm-close"
							onClick={this.props.closeWindow}
							aria-label="Close"
						>
							×
						</button>
					</div>

					<div className="tdm-content">
						<section className="tdm-card">
							<div className="tdm-card-header">
								<div>
									<h4>Kandidater</h4>
									<p>
										Disse kandidatene vil få den nye testen.
									</p>
								</div>
							</div>

							<div className="tdm-table-wrapper">
								<table
									id="testUsers_table"
									className="tdm-table"
								>
									<thead>
										<tr>
											<th>
												{strings.firstname +
													', ' +
													strings.lastname}
											</th>
											<th>{strings.email}</th>
											<th>{strings.telephone}</th>
											<th>{strings.gender}</th>
										</tr>
									</thead>

									<tbody>
										{filteredTestUsers.map((testUser) => (
											<tr key={testUser.id}>
												<td>
													<strong>
														{testUser.firstName
															? `${testUser.firstName} ${testUser.lastName}`
															: '-'}
													</strong>
												</td>
												<td>{testUser.email || '-'}</td>
												<td>{testUser.phone || '-'}</td>
												<td>
													{this.getCandidateGenderLabel(
														testUser.id,
														this.props
															.batchedFilteredTestResults
													)}
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</section>

						<section className="tdm-card tdm-settings-card">
							{!hasConfirmedCost ? (
								<>
									<h4>Bekreft utsending</h4>

									<p className="tdm-description">
										Bekreft at du vil opprette ny test for
										de valgte kandidatene.
									</p>

									<div className="tdm-summary">
										<div>
											<span>Kandidater</span>
											<strong>
												{filteredTestUsers.length}
											</strong>
										</div>

										<div>
											<span>Tilgjengelige tester</span>
											<strong>
												{availableTestTypes.length || 0}
											</strong>
										</div>
									</div>
								</>
							) : (
								<form
									className="tdm-form"
									onSubmit={handleSubmit}
								>
									<h4>Testinnstillinger</h4>

									<div className="tdm-field">
										<label>{strings.test_type}</label>

										<select
											className="tdm-input"
											value={type || ''}
											name="type"
											onChange={(event) => {
												this.setState({
													type: event.target.value,
												});
											}}
										>
											{Object.entries(TEST_TYPES)
												.filter(([, value]) =>
													availableTestTypes.includes(
														value
													)
												)
												.map(([key, value]) => (
													<option
														key={key}
														value={value}
													>
														{TEST_TYPE_NAMES[value]}
													</option>
												))}
										</select>
									</div>

									{Boolean(groups.length) && (
										<div className="tdm-field">
											<label>{strings.choosegroup}</label>

											<button
												type="button"
												className={classNames(
													'tdm-toggle-card',
													{
														'tdm-toggle-card--active':
															isAddingGroup,
													}
												)}
												onClick={() => {
													if (!isAddingGroup) {
														this.setState({
															isAddingGroup: true,
															groupId:
																UsersGroups[0]
																	.id,
														});
													} else {
														this.setState({
															isAddingGroup: false,
															groupId: null,
														});
													}
												}}
											>
												<span>
													{isAddingGroup
														? strings.addtogroup
														: 'Ingen gruppe valgt'}
												</span>
												<small>
													{isAddingGroup
														? 'Testen knyttes til valgt gruppe.'
														: 'Kandidatene får test uten gruppetilknytning.'}
												</small>
											</button>
										</div>
									)}

									{isAddingGroup && (
										<div className="tdm-field">
											<label>{strings.groupname}</label>

											<select
												className="tdm-input"
												value={
													UsersGroups.find(
														(group) =>
															group.id ===
															this.state.groupId
													)?.name || groups[0]
												}
												name="group"
												onChange={(event) => {
													const chosenGroup =
														UsersGroups.find(
															(userGroup) =>
																userGroup.name ===
																event.target
																	.value
														);

													this.setState({
														groupId: chosenGroup
															? chosenGroup.id
															: null,
													});
												}}
											>
												{groups.map((group) => (
													<option
														key={group}
														value={group}
													>
														{group}
													</option>
												))}
											</select>
										</div>
									)}

									{showInstructionOptions && (
										<div className="tdm-instruction-card">
											<h5>
												Instruksjoner for kandidatinfo
											</h5>

											<label
												className={classNames(
													'tdm-radio-card',
													{
														'tdm-radio-card--active':
															infoCandidateAdmin,
													}
												)}
											>
												<input
													checked={infoCandidateAdmin}
													type="radio"
													name="velg anamnese"
													onChange={(e) => {
														if (e.target.checked) {
															this.setState({
																infoCandidateAdmin: true,
																childSelfStarting: false,
															});
														}
													}}
												/>

												<span>
													<b>
														{
															strings.fillSelfCandidateInfo
														}
													</b>
													<small>
														{
															strings.fillKandidateInformation1
														}
													</small>
												</span>
											</label>

											<label
												className={classNames(
													'tdm-radio-card',
													{
														'tdm-radio-card--active':
															childSelfStarting,
													}
												)}
											>
												<input
													checked={childSelfStarting}
													type="radio"
													name="velg anamnese"
													onChange={(e) => {
														if (e.target.checked) {
															this.setState({
																childSelfStarting: true,
																infoCandidateAdmin: false,
															});
														}
													}}
												/>

												<span>
													<b>
														{
															strings.letCandidateFillInfo
														}
													</b>
													<small>
														{
															strings.fillKandidateInformationSelf1
														}
													</small>
												</span>
											</label>

											<p className="tdm-note">
												{strings.candidateInfoCommon}
											</p>
											<p className="tdm-note">
												{strings.candidateInfoReminder}
											</p>
										</div>
									)}
								</form>
							)}
						</section>
					</div>

					<div className="tdm-footer">
						<button
							type="button"
							className="lit-btn bg-negative2"
							onClick={handleCancel}
						>
							{strings.cancel}
						</button>

						{!hasConfirmedCost ? (
							<button
								type="button"
								className="lit-btn bg-primary"
								onClick={() => this.confirmDispatchSettings()}
								disabled={
									!availableLanguage.length ||
									!availableTestTypes.length
								}
							>
								{strings.confirm}
							</button>
						) : (
							<button
								type="submit"
								form="tdm-dispatch-form"
								className="lit-btn bg-primary"
								disabled={newTestCount !== 1 || !type}
								onClick={() => {
									const form =
										document.querySelector('.tdm-form');

									if (form) {
										form.requestSubmit();
									}
								}}
							>
								{newTestCount > 1
									? strings.create_tests
									: strings.createnewtest}
							</button>
						)}
					</div>
				</div>
			</div>
		);
	}
}
export default TestDispatchModal;
